import { render, staticRenderFns } from "./presentacion-modulo.vue?vue&type=template&id=22d0fcaf&scoped=true&"
import script from "./presentacion-modulo.vue?vue&type=script&lang=js&"
export * from "./presentacion-modulo.vue?vue&type=script&lang=js&"
import style0 from "./presentacion-modulo.vue?vue&type=style&index=0&id=22d0fcaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0fcaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
